var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_vm._v(" 请在左侧菜单选择需要使用的功能 ")])}
var staticRenderFns = []

export { render, staticRenderFns }